import React, { useContext } from "react";

import {
    LinearProgress as MuiLinearProgress,
    Paper
} from "@material-ui/core";

import { Typography } from "../../../../../../common/components/libs";
import PageStoreContext from "../../context";
import { useStores } from "../../../../../../hooks";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { MenuCategoryRevenueStats } from "../../../../../../services/stats/models";
import { localize } from "../../../../../../common/libs";
import styled from "styled-components";

const LinearProgress = styled(MuiLinearProgress)`
  height: 14px;
  width: 180px;
  border-radius: 3px;
  background: ${props => props.theme.palette.grey[200]};
`;

const TopCategoriesCard = ({ item }: { item: MenuCategoryRevenueStats }) => {
    const pageStore = useContext(PageStoreContext);
    const { constantsStore } = useStores();
    const formatter = constantsStore.getCurrencyFormatter(item.revenue.currencyId);
    const { ordersAmount, totalOrdersPrice } = pageStore.generalStats;
    const revenuePercentage = (item.revenue.price / totalOrdersPrice.price) * 100;
    const ordersPercentage = (item.totalOrdersCount / ordersAmount) * 100;

    const { t } = useTranslation(["general", "stats"]);

    return (
        <Paper>
            <Typography variant={"h6"} style={{ marginLeft: 15 }}>
                {t("stats:category")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5, marginLeft: 15 }}>
                {localize(item.menuCategoryName)}
            </Typography>
            <Typography variant={"h6"} style={{ marginTop: 20, marginLeft: 15 }}>
                {t("stats:revenueOrders")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5, marginLeft: 15 }}>
                {formatter.toShowFormatted(item.revenue.price)} <br/>
                {item.totalOrdersCount} шт.
            </Typography>
            <Typography variant={"h6"} style={{ marginTop: 20, marginLeft: 15 }}>
                {t("stats:percentOfRevenue")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5, marginLeft: 15 }}>
                {revenuePercentage.toFixed(2)} %
                <LinearProgress
                    variant="determinate"
                    value={revenuePercentage}
                    color="secondary"
                />
            </Typography>
            <Typography variant={"h6"} style={{ marginTop: 20, marginLeft: 15 }}>
                {t("stats:percentOfOrders")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5, marginLeft: 15, marginBottom: 15 }}>
                {ordersPercentage.toFixed(2)} %
                <LinearProgress
                    variant="determinate"
                    value={ordersPercentage}
                    color="secondary"
                />
            </Typography>
        </Paper>
    );
};

export default observer(TopCategoriesCard);
